import { Flex, Heading, Text, useMediaQuery, Box } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface HeadingTableProps {
  isShowTable: boolean;
  setIsShowTable: Dispatch<SetStateAction<boolean>>;
}

export const HeadingTable = ({
  isShowTable,
  setIsShowTable,
}: HeadingTableProps) => {
  const [isMobileSize] = useMediaQuery("(max-width: 992px)");

  function handleToggleShowTable() {
    setIsShowTable(!isShowTable);
  }

  return (
    <Flex flexDirection="column" margin={isMobileSize ? "0px auto" : "none"}>
      {isMobileSize ? (
        <Flex justifyContent="space-between" alignItems="center">
          <Heading
            
            fontSize="18px"
            fontWeight="bold"
            color="#10125A"
            textDecoration={isShowTable ? "underline" : "none"}
            textDecorationColor={isShowTable ? "#009D57" : "none"}
          >
            Extrato de Resgates
          </Heading>
          <Box onClick={handleToggleShowTable}>
            {isShowTable ? (
              <FiChevronUp size={40} color="#009D57" />
            ) : (
              <FiChevronDown size={40} color="#009D57" />
            )}
          </Box>
        </Flex>
      ) : (
        <Heading
          
          fontSize="20px"
          fontWeight="bold"
          color="#10125A"
        >
          Extrato de Resgates
        </Heading>
      )}

      <Text
        margin={isMobileSize ? "10px 0px 20px 0px" : "10px 0px 20px 0px"}
        
        fontSize="15px"
        fontWeight="normal"
        color="#6D6C6C"
      >
        Confira abaixo seus resgates efetuados. 
      </Text>
    </Flex>
  );
};
